import { render, staticRenderFns } from "./ACheckbox.vue?vue&type=template&id=cf3fdd2c&scoped=true&"
import script from "./ACheckbox.vue?vue&type=script&lang=js&"
export * from "./ACheckbox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf3fdd2c",
  null
  
)

export default component.exports